import { NoAnnotationsDuoIcon, Text, XMarkCircleFillIcon } from "@flat-ui";
import { Stack } from "@mui-wrapper";
import { PALETTE_VARS } from "@styles/palette-vars";
import { getSvgColoredIconCss } from "@utils/ui-utils";
/** Empty state of the summary, with the same look as the empty annotations table but sized to fit the chart */
export function MarkupsSummaryEmpty({
  message,
  isError = false,
  title = "No annotations",
  icon = <NoAnnotationsDuoIcon sx={{
    width: "2.5rem",
    height: "2.5rem"
  }} />
}) {
  return <Stack sx={{
    alignItems: "center",
    textAlign: "center",
    gap: 2
  }}>
      <Stack sx={{
      width: "7.5rem",
      height: "7.5rem",
      borderRadius: "50%",
      backgroundColor: "surfaces.secondary",
      justifyContent: "center",
      alignItems: "center"
    }}>
        {isError ? <XMarkCircleFillIcon sx={{
        ...getSvgColoredIconCss(PALETTE_VARS.error.main),
        width: "2.5rem",
        height: "2.5rem"
      }} /> : icon}
      </Stack>
      <Stack sx={{
      gap: 0.5
    }}>
        <Text variant="heading20">{isError ? "Error" : title}</Text>
        <Text variant="bodyM" sx={{
        color: "text.secondary"
      }}>
          {message}
        </Text>
      </Stack>
    </Stack>;
}